import {
  Icon,
  type IconProps,
  Stack,
  type StackProps,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useRef } from 'react';

interface SearchResultItemProps {
  icon?: IconProps['iconName'];
  title: string;
  subtitle?: string;
  onClick: () => void;
  sx?: StackProps['sx'];
  highlighted?: boolean;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({
  icon,
  title,
  subtitle,
  onClick,
  sx = [],
  highlighted = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Stack
      spacing={1}
      direction='row'
      onMouseDown={onClick}
      sx={[
        {
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          borderBottom: '1px solid',
          borderColor: 'grey.300',
          '&:hover': {
            backgroundColor: 'primary.100',
          },
        },
        highlighted && {
          backgroundColor: 'primary.100',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      ref={ref}
    >
      {icon && <Icon iconName={icon} standalone />}
      <Stack direction='column' sx={{ textAlign: 'left' }}>
        <Typography variant='view-label-primary'>{title}</Typography>
        {subtitle && (
          <Typography variant='view-label-secondary'>{subtitle}</Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default SearchResultItem;
